import { render, staticRenderFns } from "./VerticalExportPage.vue?vue&type=template&id=6704bec5&scoped=true"
import script from "./VerticalExportPage.vue?vue&type=script&lang=ts"
export * from "./VerticalExportPage.vue?vue&type=script&lang=ts"
import style0 from "./VerticalExportPage.vue?vue&type=style&index=0&id=6704bec5&prod&lang=scss&scoped=true"
import style1 from "./VerticalExportPage.vue?vue&type=style&index=1&id=6704bec5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704bec5",
  null
  
)

export default component.exports